import { Injectable } from "@angular/core";
import { IdentityService } from "../authentication/identity.service";
import { ConnectionServices } from "../authentication/connection/connection.service";
import { catchError, map, Observable, throwError } from "rxjs";
import { ReadParametersCommand } from "./command/read-parameters.command";
import { GetParameterByKeyCommand } from "./command/get-parameter.command";

@Injectable()
export class GeneralParametersService {
  private titleMessage: string;

  constructor(
    private _identityService: IdentityService,
    private _connectionService: ConnectionServices,
    // private _notificationsService: NotificationsService,
    // private _multiregionService: MultiRegionService
  ) {
    this.titleMessage = 'carrier.configuration.general_parameters.title'
  }

//   public updateParameters(data: IParametersFormData): Observable<any> {
//     let command = new ParametersCommand();
//     command.addCommandBody(data);
//     command.setCarrierId(+this._identityService.userId);
//     return this._connectionService
//       .Request(command)
//       .map((response: any) => {
//         this._notificationsService.showSuccessMessage(
//           this.titleMessage,
//           'toast.shared.message.successful_message_modify'
//         );
//         return response;
//       })
//       .catch(error => {
//         this._notificationsService.showHttpErrorMessage(
//           this.titleMessage,
//           error
//         );
//         return Observable.throw(false);
//       });
//   }

//   public updateParameter(parameterKey: string, value: any): Observable<any> {
//     let command = new SetParameterCommand();
//     command.setParameters(<SetParameterCommandParameters>{
//       carrierUserId: +this._identityService.userId,
//       parameterKey: parameterKey,
//       value: value
//     });

//     return this._connectionService
//       .Request(command)
//       .map((response: any) => {
//         this._notificationsService.showSuccessMessage(
//           this.titleMessage,
//           'toast.shared.message.successful_message_modify'
//         );
//         return response;
//       })
//       .catch(error => {
//         this._notificationsService.showHttpErrorMessage(
//           this.titleMessage,
//           error
//         );
//         return Observable.throw(false);
//       });
//   }

  public getParameters(): Observable<any> {
    let command = new ReadParametersCommand();
    command.setCarrierId(+this._identityService.userId);

    return this._connectionService
    .Request(command)
    .pipe(
      map(response => {
        return response as any;
      }),
      catchError((error) => {
        // this._notificationsService.showHttpErrorMessage(
        //     this.titleMessage,
        //     error
        // );
        return throwError(() => false);
    }));
    // return this._connectionService
    //   .Request(command)
    //   .map((response: any) => {
    //     return response;
    //   })
    //   .catch(error => {
    //     this._notificationsService.showHttpErrorMessage(
    //       this.titleMessage,
    //       error
    //     );
    //     return Observable.throw(false);
    //   });
  }

//   public getParametersByCarrier(carrierId: number): Observable<any> {
//     let command = new ReadParametersCommand();
//     command.setCarrierId(carrierId);
//     return this._connectionService
//       .Request(command)
//       .map((response: any) => {
//         return response;
//       })
//       .catch(error => {
//         this._notificationsService.showHttpErrorMessage(
//           this.titleMessage,
//           error
//         );
//         return Observable.throw(false);
//       });
//   }

  public getParameter(key: string): Observable<any> {
    let command = new GetParameterByKeyCommand();
    command.setParameter(+this._identityService.userId, key);

    return this._connectionService
    .Request(command)
    .pipe(
      map(response => {
        return response as any;
      }),
      catchError((error) => {
        // this._notificationsService.showHttpErrorMessage(
        //     this.titleMessage,
        //     error
        // );
        return throwError(() => false);
    }));

    // return this._connectionService
    //   .Request(command)
    //   .map((response: any) => {
    //     return response;
    //   })
    //   .catch(error => {
    //     this._notificationsService.showHttpErrorMessage(
    //       this.titleMessage,
    //       error
    //     );
    //     return Observable.throw(false);
    //   });
  }

//   getPaymentMethodConfig() {
//     let command = new GetPaymentMethodConfigCommand();
//     command.setParameters({carrierId: this._identityService.userId});

//     return this._connectionService
//       .Request(command)
//       .map((response: PaymentConfigDTO) => {
//         return response;
//       })
//       .catch(error => {
//         return Observable.throw(false);
//       });
//   }

//   updatePaymentMethodsConfig(updateConfig: PaymentConfigDTO) {
//     let command = new UpdatePaymentMethodsConfigCommand();
//     command.setUrl(this._identityService.userId);
//     command.setParameters(updateConfig);

//     return this._connectionService
//       .Request(command)
//       .map((response: any) => {
//         return response;
//       })
//       .catch(error => {
//         return Observable.throw(false);
//       });
//   }
}
